import axiosInstance from '../axios/axios-instance';
import { TrustpilotInviteResponseDto } from 'shared/interfaces/trustpilot-invite/trustpilot-invite-response.dto';

export const trustpilotInvite = {
  /**
   * Records a trustpilot invite displayed.
   * @returns The invite id and url.
   */
  async recordTrustpilotInviteDisplayed(): Promise<TrustpilotInviteResponseDto> {
    const response = await axiosInstance.get<TrustpilotInviteResponseDto>('/trustpilot-invite/record-displayed');
    return response.data;
  },

  /**
   * Records a trustpilot invite redirected.
   * @param id - The id of the invite to record the redirect for.
   */
  async recordTrustpilotInviteRedirected(id: number): Promise<void> {
    await axiosInstance.get(`/trustpilot-invite/record-redirected/${id}`);
  },
};
